import React from 'react';
import { Area } from '@ant-design/plots';

const AreaChart = ({
  data,
  colors,
  chartHeight = 300,
  xField = 'date',
  yField = 'totalSeconds',
  theme = 'classicDark',
}) => {
  
  const transformedData = data.map((item) => ({
    ...item,
    hours: parseFloat((item[yField] / 3600).toFixed(2)),
  }));
  
  const config = {
    theme,
    data: transformedData,
    height: chartHeight,
    xField,
    yField: 'hours', 
    style: {
      fill: `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 100%)`,
    },
   
    line: {
      style: {
        stroke: colors[2],
        strokeWidth: 2,
      },
      tooltip: false,
    },

  };

  return <Area {...config} />;
};

export default AreaChart;